<script setup>
import ApikomTaskTable from '@frontJs/components/tables/projectManagement/tasks/ApikomTaskTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    ongoing: 0,
    closed: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['open'],
            theme: ['dev_seo'],
        }),
        axios.post(route('front.projectManagement.task.postTaskCount'), {
            status: ['closed'],
            theme: ['dev_seo'],
        }),
    ])
        .then(([ongoingResponse, closedResponse]) => {
            data.value.ongoing = ongoingResponse.data.count;
            data.value.closed = closedResponse.data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>DEV SEO - SEO/GEO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - SEO/GEO - DEV SEO </PageTitle>

    <TabLayout
        :tabs="{
            ongoing: {
                title: 'En cours',
                total: data.ongoing,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'dev_seo_ongoing',
                    theme: 'dev_seo',
                    status: 'open',
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'hourly',
                            theme: 'dev_seo',
                            noOneResponsible: true,
                            name: 'Optimisations techniques SEO',
                        },
                    ),
                }),
            },
            closed: {
                title: 'Fermé',
                total: data.closed,
                content: h(ApikomTaskTable, {
                    userSessionKey: 'dev_seo_closed',
                    theme: 'dev_seo',
                    status: 'closed',
                    createTaskUrl: route(
                        'front.projectManagement.task.createTask',
                        {
                            type: 'hourly',
                            theme: 'dev_seo',
                            noOneResponsible: true,
                            name: 'Optimisations techniques SEO',
                        },
                    ),
                }),
            },
        }"
        :loading="loading"
    />
</template>
